import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export function RouterRoot() {
  const navigate = useNavigate();

  useEffect(() => {
    window._navigate = (path: string) => navigate(path);

    return () => {
      window._navigate = undefined;
    };
  }, [navigate]);

  return <Outlet />;
}
